import classNames from 'classnames'
import React, { PropTypes } from 'react'
import IconSVG from 'svg-inline-react'
import styles from './style.styl'

const BotAvatar = ({ color, className, type, style }) => (
  <div className={classNames(styles.BotAvatar, className)} style={{ color, ...style }}>
    <IconSVG src={ type === 'circle'
                ? require('!svg-inline-loader?removeTags=true!./bot-avatar-round.svg')
                : require('!svg-inline-loader?removeTags=true!./bot-avatar-square.svg')
                 } />
  </div>
)
BotAvatar.propTypes = {
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.oneOf(['circle', 'rect']),
}
BotAvatar.defaultProps = {
  type: 'circle',
}

export default BotAvatar



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/BotAvatar/index.js